import React, { FC } from 'react';
import { StepContainerStyled, StepTextStyled } from './styled';
import { StepProps } from './types';

export const Step: FC<StepProps> = ({ children, fillColor, enableHover, hoverColor }) => {
  return (
    <StepTextStyled
      fillColor={fillColor}
      enableHover={enableHover}
      hoverColor={hoverColor}
      data-testid="progressbar_step"
    >
      {children}
    </StepTextStyled>
  );
};

export const ProgressStepBar = ({ children }) => {
  return <StepContainerStyled data-testid="progressbar_week">{children}</StepContainerStyled>;
};
